import Immutable from 'seamless-immutable';
import { actionTypeGenerator } from './APIActionTypeGenerator';
import { STATUS } from '../../constants';

const initialState = Immutable({});

const apiReducer = (state = initialState, { type, key, payload, response }) => {
  if (key === undefined) return state;

  const { REQUEST, SUCCESS, FAILURE } = actionTypeGenerator(key);
  const { PENDING, RESOLVED, ERROR } = STATUS;

  switch (type) {
    case REQUEST:
      return state.merge({
        [key]: {
          payload,
          response: null,
          status: PENDING,
        },
      });
    case SUCCESS:
      return state.merge({
        [key]: {
          payload,
          response,
          status: RESOLVED,
        },
      });
    case FAILURE:
      return state.merge({
        [key]: {
          payload,
          response,
          status: ERROR,
        },
      });
    default:
      return state;
  }
};

export default apiReducer;



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/redux/API/APIReducer.js